import FormComponent, { FormComponentProps } from './FormComponent';
export default FormComponent;
export type { FormComponentProps };
